export default class InfoQuestion {
  id!: string;
  code: string;
  question: string;
  questionType: string;
  options: string[];
  logicQuestion: string;
  logicQuestionResponse: string;
  multiSelect: boolean;
  isActive: boolean;

  constructor(
    code: string = "",
    question: string = "",
    questionType: string = "",
    options: string[] = [],
    logicQuestion: string = "",
    logicQuestionResponse: string = "",
    multiSelect: boolean = false,
    isActive: boolean = true
  ) {
    this.code = code;
    this.question = question;
    this.questionType = questionType;
    this.options = options;
    this.logicQuestion = logicQuestion;
    this.logicQuestionResponse = logicQuestionResponse;
    this.multiSelect = multiSelect;
    this.isActive = isActive;
  }
}

export type InfoQuestionStatus = {
  id: string;
  isActive: boolean;
};
